import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/*
 * import fontawesome icons
 */
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

function Spinner() {
    return (
	    <div className="vw-vh-100 flex-vh-align">
            <FontAwesomeIcon icon={faCircleNotch} size="4x" spin />
        </div>
    );
}

export default Spinner;